export const LOGO_URL = "/logo.png";

// Anti-flicker delays (ms)
export const COPY_FEEDBACK_DURATION_MS = 1200;
export const OUTPUT_SCROLL_DELAY_MS = 100;

// History persistence
export const MAX_HISTORY_ITEMS = 20;

// Framer-motion presets
export const FADE_IN_INITIAL = { opacity: 0 };
export const FADE_IN_ANIMATE = { opacity: 1 };
export const FADE_OUT_EXIT = { opacity: 0 };
export const SLIDE_UP_INITIAL = { opacity: 0, y: 14 };
export const SLIDE_UP_ANIMATE = { opacity: 1, y: 0 };
export const SLIDE_UP_TRANSITION = { duration: 0.35 };

// ============ V2 — 4 modes ============

/** Top-level modes (order is IMPÉRATIF: CORDIALEMENT, REVERSE, ANTIDOTE, BULLSHIT SCORE) */
export const TOP_MODES = ["cordialement", "reverse", "antidote", "bullshit"];

/** REVERSE intensity keys and default */
export const REVERSE_INTENSITIES = ["franc", "suffit", "nuclear"];
export const REVERSE_INTENSITY_DEFAULT = "suffit";

/** Diplomacy slider (CORDIALEMENT only) — 5 anchored labels for a 0-100 scale */
export const DIPLOMACY_DEFAULT = 50;
export const DIPLOMACY_STEPS = [
  { at: 0, key: "assume" },
  { at: 25, key: "direct" },
  { at: 50, key: "professional" },
  { at: 75, key: "diplomatic" },
  { at: 100, key: "un" },
];

/** V2 palette per top mode (used for accent/tinting) */
export const TOP_MODE_COLORS = {
  cordialement: "#B5EAD7",
  reverse: "#FFDAC1",
  antidote: "#C7CEEA",
  bullshit: "#FFF2B2",
};

/** localStorage keys — documented in /legal, values NEVER sent to server outside their scoped request */
export const LS_KEYS = {
  history: "history",
  lang: "lang",
  privacyNoticeSeen: "privacy_notice_seen",
  topMode: "top_mode",
  diplomacy: "diplomacy",
  reverseIntensity: "reverse_intensity",
};
